export async function ApiGet(url, header) {
  try {
    if (header === undefined) {
      return await fetch(url, {
        method: 'GET',
      });
    } else {
      header['Content-Type'] = 'application/json';

      return await fetch(url, {
        method: 'GET',
        headers: header
      });
    }
  } catch (error) {
    //console.log(error);
    return null;
  }
}